import React, { useState } from 'react';
import { X } from 'lucide-react';

const funFacts = [
  "RHY WENT TO FULL SAIL WITH A GENIUS ROOMMATE (Parker Chase) AND SHARED APARTMENT",
  "RHY USED TO LIVE NEXT DOOR TO KANYE'S CHILDHOOD HOME IN CHICAGO",
  "RHY USED TO LIVE IN THE NAWF SIDE OF ATLANTA. THEY ALL CALLED HIM JUNIOR OVER THERE",
  "RHY USED TO GO TO MIAMI EVERY SUMMER WITH FAMILY",
  "RHY USED TO BE HOMELESS, DOING WHATEVER POSSIBLE TO SURVIVE FOR A COUPLE MONTHS.",
  "RHY USED TO LIVE IN GIMPO-SI WHICH IS A SUBURB OUTSIDE OF WEST SEOUL IN SOUTH KOREA",
  "RHY WENT TO LA FOR THE FIRST TIME AND GOT STRANDED AND NOBODY WHO LIVED THERE HELPED ONLY PEOPLE WHO LIVED HUNDREDS OF MILES AWAY.",
  "RHY USUALLY ROAMS AROUND IN CENTRAL TEXAS SO FIND HIM AND PLACE YOUR HAND ON HIS SHOULDER FOR FULL ACCESS TO EVERYTHING.",
  "BETWEEN THE YEARS OF 2021-2024, RHY USED TO WORK AS A ORDER SELECTOR, LUMBERJACK, DELIVERY DRIVER, SALESMAN, AND PARTS MANUFACTURER FOR THE 2025 TOYOTA TUNDRA.",
  "RHY HAS MADE OVER 4000 SONGS OVER THE SPAN OF THE 6 YEARS OF HARD WORK. LEARNING HOW TO MAKE BEATS, MAKE SONGS (ENGLISH OR SPANISH), ENGINEER ANY SONG, SING, CREATE AND CULTIVATE ANY GENRE OF MUSIC FROM ANY BEDROOM IN THE WORLD."
];

const RhyLogo = () => {
  const [showFact, setShowFact] = useState(false);
  const [currentFact, setCurrentFact] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  const handleLogoClick = () => {
    setIsAnimating(true);
    setCurrentFact(Math.floor(Math.random() * funFacts.length));
    setShowFact(true);
    setTimeout(() => setIsAnimating(false), 300);
  };

  return (
    <>
      {/* RHY Logo Sticker - Top Right */}
      <div 
        className="fixed top-4 right-4 z-50 cursor-pointer group"
        onClick={handleLogoClick}
        data-testid="rhy-logo-sticker"
      >
        <div className={`relative w-16 h-16 transition-transform duration-300 ${isAnimating ? 'scale-125 rotate-12' : 'hover:scale-110'}`}>
          {/* Sticker Background */}
          <svg viewBox="0 0 100 100" className="w-full h-full drop-shadow-lg">
            {/* Sticker shape with slight peel effect */}
            <defs>
              <linearGradient id="stickerGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#1a1a1a" />
                <stop offset="50%" stopColor="#2d2d2d" />
                <stop offset="100%" stopColor="#1a1a1a" />
              </linearGradient>
              <filter id="stickerShadow">
                <feDropShadow dx="2" dy="2" stdDeviation="2" floodOpacity="0.5"/>
              </filter>
              <linearGradient id="peelGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#3d3d3d" />
                <stop offset="100%" stopColor="#ffffff" stopOpacity="0.1" />
              </linearGradient>
            </defs>
            
            {/* Main sticker circle */}
            <circle cx="50" cy="50" r="45" fill="url(#stickerGrad)" filter="url(#stickerShadow)" stroke="#444" strokeWidth="2"/>
            
            {/* Inner ring */}
            <circle cx="50" cy="50" r="38" fill="none" stroke="#555" strokeWidth="1" strokeDasharray="4 2"/>
            
            {/* RHY Text */}
            <text x="50" y="58" textAnchor="middle" fill="#fff" fontSize="24" fontWeight="bold" fontFamily="Bebas Neue, sans-serif" letterSpacing="2">
              RHY
            </text>
            
            {/* Small star accents */}
            <text x="22" y="35" fill="#ffd700" fontSize="10">★</text>
            <text x="75" y="35" fill="#ffd700" fontSize="10">★</text>
            <text x="50" y="82" fill="#ffd700" fontSize="8">★</text>
            
            {/* Peel corner effect */}
            <path d="M 85 15 Q 90 10, 95 15 Q 90 20, 85 15" fill="url(#peelGrad)" opacity="0.8"/>
          </svg>
          
          {/* Tap hint */}
          <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity">
            <span className="text-[10px] text-white/50 font-mono">TAP FOR FUN FACT</span>
          </div>
        </div>
      </div>

      {/* Fun Fact Popup */}
      {showFact && (
        <div 
          className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-fade-in"
          onClick={() => setShowFact(false)}
        >
          <div 
            className="relative max-w-md w-full bg-gradient-to-br from-[#1a1a1a] to-[#0a0a0a] border border-white/20 rounded-2xl p-6 shadow-2xl animate-scale-in"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close button */}
            <button 
              onClick={() => setShowFact(false)}
              className="absolute top-3 right-3 text-white/50 hover:text-white transition-colors"
            >
              <X className="w-5 h-5" />
            </button>
            
            {/* Header */}
            <div className="flex items-center gap-3 mb-4">
              <span className="text-2xl">🎤</span>
              <h3 className="font-heading text-xl text-white tracking-wider">FUN FACT #{currentFact + 1}</h3>
            </div>
            
            {/* Fact content */}
            <p className="font-mono text-sm text-white/80 leading-relaxed">
              {funFacts[currentFact]}
            </p>
            
            {/* Footer */}
            <div className="mt-6 pt-4 border-t border-white/10 flex justify-between items-center">
              <span className="text-xs text-white/40 font-mono">{currentFact + 1} of {funFacts.length}</span>
              <button 
                onClick={handleLogoClick}
                className="px-4 py-2 bg-white/10 hover:bg-white/20 text-white text-sm font-mono rounded-lg transition-colors"
              >
                ANOTHER FACT
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes scale-in {
          from { opacity: 0; transform: scale(0.9); }
          to { opacity: 1; transform: scale(1); }
        }
        .animate-fade-in { animation: fade-in 0.2s ease-out; }
        .animate-scale-in { animation: scale-in 0.3s ease-out; }
      `}</style>
    </>
  );
};

export default RhyLogo;
